var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:{
    'form--card': true,
    'card--color-light': !_vm.dark,
    'card--color-dark' : _vm.dark
  }},[(_vm.hasProgressBar)?_c('v-progress-linear',{staticClass:"progressBar",attrs:{"absolute":"","top":"","query":"","height":"30px","value":_vm.progress}},[_c('span',[_vm._v("Step "+_vm._s(_vm.currentStep))])]):_vm._e(),_vm._t("full"),(this.$slots['title'])?_c('v-card-title',{staticClass:"text--title-responsive form--title"},[_vm._t("title")],2):_vm._e(),_c('v-card-text',[_vm._t("body")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }